import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { ProductCategory, ProductCategoryService } from 'src/app/core/product-category.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-companies-product-category-dialog',
  templateUrl: './companies-product-category-dialog.component.html',
  styleUrls: ['./companies-product-category-dialog.component.scss'],
})
export class CompaniesProductCategoryDialogComponent {
  company_id: string;
  company_product_category: string;
  set_product_category_form_group: FormGroup = this.form_service.set_product_category_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;
  product_categories: Observable<ProductCategory[]>;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesProductCategoryDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    private product_category_service: ProductCategoryService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
    this.company_product_category = data.product_category;
    this.product_categories = this.product_category_service.listAllProductCategories().pipe(
      map(response => {
        return response.data;
      }),
    );
  }

  ngOnInit(): void {
    this.set_product_category_form_group
      .get(this.form_service.product_category_label)
      ?.setValue(this.company_product_category);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const product_category = this.set_product_category_form_group.get(
        this.form_service.product_category_label,
      )?.value;
      this.setProductCategory(this.company_id, product_category);
    }
  }

  setProductCategory(company_id: string, product_category: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setProductCategory(company_id, product_category).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_product_category_form_group);
  }
}
